<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path
        d="M12.1727 11.9998L10.0509 9.87869C9.66031 9.48829 9.66022 8.85514 10.0506 8.46452V8.46452C10.441 8.07376 11.0745 8.07357 11.4651 8.46419L14.2936 11.2927C14.6842 11.6833 14.6842 12.3164 14.2936 12.7069L11.4651 15.5355C11.0745 15.9261 10.441 15.9259 10.0506 15.5351V15.5351C9.66022 15.1445 9.66031 14.5114 10.0509 14.121L12.1727 11.9998Z"
        v-bind:fill="color" />
    </g>
    <defs>
      <clipPath id="clip0_2093_16770">
        <rect width="24" height="24" v-bind:fill="color" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: ["color"]
}
</script>